import axios from 'axios'

export interface OrderSessionOwner {
  id: string
  name: string
  expired?: boolean
}

export interface UpdateSessionRequest {
  id: string
}

export interface UpdateOrderSessionResponse {
  ownerUser: OrderSessionOwner
  disabled?: boolean
}

export interface ReleaseSessionRequest {
  id: string
}

export interface UpdateOrderSessionBody {
  order_changed?: boolean
}

export function update_session(params: UpdateSessionRequest, payload?: UpdateOrderSessionBody) {
  return axios.patch<UpdateOrderSessionResponse>(`/vendor/order_session/${params.id}/update`, payload)
}

export function release_session(payload: ReleaseSessionRequest) {
  return axios.patch<void>(`/vendor/order_session/${payload.id}/release`)
}
